import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useActiveAthlete } from "@/hooks/useActiveAthlete";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import Timeline from "@/components/Timeline";
import AddMilestoneForm from "@/components/AddMilestoneForm";
import { Flag, Plus } from "lucide-react";

const Milestones = () => {
  const [addOpen, setAddOpen] = useState(false);

  const { athlete } = useActiveAthlete();

  const { data: milestones = [], isLoading } = useQuery<any[]>({
    queryKey: ["/api/athletes", athlete?.id, "milestones"],
    enabled: !!athlete?.id,
  });

  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      {/* Page banner */}
      <div className="rounded-xl border border-[#E0A458]/45 bg-gradient-to-r from-[#0D1B2A] to-[#1B263B] px-4 py-4 shadow-lg shadow-black/25 mb-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Flag className="h-5 w-5 text-[#E0A458]" />
          <h1 className="font-montserrat font-bold text-xl text-white">Legacy Timeline</h1>
        </div>
        {athlete && (
          <Button
            onClick={() => setAddOpen(true)}
            className="bg-[#E0A458] text-black hover:bg-[#f0b467] font-semibold"
            size="sm"
          >
            <Plus className="h-4 w-4 mr-1" />
            Add Milestone
          </Button>
        )}
      </div>

      {!athlete ? (
        <Card className="border border-[#E0A458]/20 bg-[#0D1B2A]">
          <CardContent className="p-8 text-center">
            <Flag className="h-12 w-12 text-[#E0A458]/50 mx-auto mb-3" />
            <p className="text-slate-300 font-semibold">No athlete profile yet</p>
            <p className="text-sm text-slate-400 mt-1">Create an athlete profile on your Dashboard to start tracking milestones.</p>
          </CardContent>
        </Card>
      ) : (
        <Card className="border border-[#E0A458]/20 bg-[#0D1B2A]">
          <CardContent className="p-6">
            <Timeline milestones={milestones} loading={isLoading} />
          </CardContent>
        </Card>
      )}

      <Dialog open={addOpen} onOpenChange={setAddOpen}>
        <DialogContent className="w-[calc(100vw-2rem)] max-w-xl max-h-[90vh] overflow-y-auto bg-[#0D1B2A] border border-[#E0A458]/30 text-white">
          <AddMilestoneForm
            athleteId={athlete?.id}
            onSuccess={() => setAddOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Milestones;
